import React from 'react';
import { Button } from 'react-bootstrap';


export default function ArButton({variant='primary', children, ...rest}){
const cls = variant === 'accent' ? 'btn-aroco-accent' : 'btn-aroco-primary';
return <Button className={cls} {...rest}>{children}</Button>;
}